module.exports = __webpack_public_path__ + "img/icon_jx500.faafc7f3.png";